<template>
  <div class="commissons-detail">
    <!-- 投保单订单详情服务费信息 -->
    <!-- 无数据状态 -->
    <template v-if="data.length == 0">
      <div class="table">
        <div class="tr head">
          <div class="big-td-index">期数</div>
          <div class="child-box">
            <div class="big-td-index big-td-index1" v-if="['1', '2'].includes(userInfo.level)">服务费归属</div>
            <div class="child-box">
              <div class="big-td-product">产品/险种名称</div>
              <div class="td">保费（元）</div>
              <div class="td">服务费比例</div>
              <div class="td">服务费(元）</div>
              <div class="td" v-if="userInfo.level != 3">净收入（元）</div>
              <div class="td" v-if="userInfo.level == 1">结算状态</div>
              <div class="td" v-if="userInfo.level == 1">未结算原因</div>
            </div>
          </div>
        </div>
        <emptyBox></emptyBox>
      </div>
    </template>
    <!-- 有数据状态 -->
    <template v-else>
      <div v-for="(bean, i) in data" :key="i" class="table-main">
        <div class="table-title" v-if="data.length > 1">保单号：{{ bean.policyNo }}</div>
        <div class="table">
          <div class="tr head">
            <div class="big-td-index">期数</div>
            <div class="child-box">
              <div class="big-td-index big-td-index1" v-if="['1', '2'].includes(userInfo.level)">服务费归属</div>
              <div class="child-box">
                <div class="big-td-product">产品/险种名称</div>
                <div class="td">保费（元）</div>
                <div class="td">
                  服务费比例
                  <el-tooltip class="item" effect="dark" content="占保费的实际服务费比例（含活动）" placement="top">
                    <span class="wenhao wenhao2">?</span>
                  </el-tooltip>
                </div>
                <div class="td">服务费(元）</div>
                <div class="td" v-if="['1', '2'].includes(userInfo.level)">
                  净收入(元）
                  <el-tooltip class="item" effect="dark" content="本身纯利润收入" placement="top">
                    <span class="wenhao">?</span>
                  </el-tooltip>
                </div>
                <div class="td" v-if="userInfo.level == 1">结算状态</div>
                <div class="td" v-if="userInfo.level == 1">未结算原因</div>
              </div>
            </div>
          </div>
          <div class="tr" v-for="(bean2, ii) in bean.children" :key="ii">
            <div class="big-td-index">{{ getPayNum(bean2.payNum) }}</div>
            <div class="child-box">
              <div class="tr" v-for="(bean3, iii) in bean2.children" :key="iii">
                <div class="big-td-index big-td-index1" v-if="['1', '2'].includes(userInfo.level)">{{ bean3.spcMechanName }}</div>
                <div class="child-box">
                  <div
                    class="tr"
                    v-for="(bean4, iii) in bean3.children"
                    :key="iii"
                    @click="switchBox(bean2, iii)"
                    :class="{ heji: bean4.isHeji }"
                    v-if="(bean2.close && iii == 0) || !bean2.close"
                  >
                    <div class="big-td-product">
                      <span v-if="bean4.additionPolicyId" class="fijiaxian">附</span>
                      {{ bean4.productName }}
                    </div>
                    <div class="td">{{ bean4.fee }}</div>
                    <div class="td" v-if="bean4.serviceCharge == '-'">-</div>
                    <div class="td" v-else>
                      {{ percent(bean4.commission) }}
                      <span class="org-text" v-if="bean4.subsidyCommission * 1">
                        +{{ percent(bean4.subsidyCommission) }}
                        <el-tooltip class="item" effect="dark" placement="top-end">
                          <div slot="content">
                            <div style="text-align: left">活动名称：{{ bean4.activityName ? bean4.activityName : '-' }}</div>
                            <div style="text-align: left">
                              活动时间：{{ bean4.activityStartTime ? bean4.activityStartTime.split(' ')[0].replace(/-/g, '/') : '-' }}
                              至
                              {{ bean4.activityEndTime ? bean4.activityEndTime.split(' ')[0].replace(/-/g, '/') : '-' }}
                            </div>
                          </div>
                          <span class="wenhao" v-if="bean4.activityName">?</span>
                        </el-tooltip>
                      </span>
                    </div>
                    <div class="td">{{ bean4.totalIncomes }}</div>
                    <div class="td" v-if="['1', '2'].includes(userInfo.level)">
                      {{ bean4.profit ? bean4.profit : '-' }}
                    </div>
                    <div class="td" v-if="userInfo.level == 1">
                      <span v-if="bean4.balanceStatus == 1">已结算</span>
                      <span v-else-if="bean4.balanceStatus == 0">未结算</span>
                      <span v-else-if="bean4.balanceStatus == -1">不符合结算条件</span>
                      <span v-else>-</span>
                      <el-popover
                        ref="popover"
                        popper-class="black-popover"
                        placement="top"
                        @show="openRecord(bean4, ii)"
                        trigger="hover"
                        :open-delay="200"
                        :popper-options="{
                          boundariesElement: 'viewport',
                          removeOnDestroy: true
                        }"
                        v-show="bean4.balanceStatus == 1"
                      >
                        <div class="content" v-loading="reVisitLod">
                          <div class="jiantou" :class="recordList.length >= 4 ? 'jiantouB' : 'jiantouB2'"></div>

                          <div class="body" v-for="(returnTime, i) in recordList" :key="i">
                            <div class="body-left">
                              <span>{{ returnTime.balanceDate ? returnTime.balanceDate : '-' }}</span>
                              <span style="margin-left: 20px">结算保费：{{ returnTime.fee ? returnTime.fee : '-' }}</span>
                              <span style="margin-left: 20px">结算金额：{{ returnTime.incomeTax ? returnTime.incomeTax : '-' }}</span>
                            </div>
                          </div>
                          <div class="zw-data" v-if="recordList.length == 0" style="text-align: center">暂无数据</div>
                        </div>
                        <span slot="reference" class="wenhao wenhao2">?</span>
                      </el-popover>
                    </div>
                    <div class="td" v-if="userInfo.level == 1">
                      {{ bean4.unsettlementReason && bean4.balanceStatus == 0 ? all.UNSETTLEMENT_REASON[bean4.unsettlementReason] : '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    orderNo: String,
    policyNo: String,
    payType: String,
  },
  data() {
    return {
      data: [],
      recordList: [],
      reVisitLod: false,
      userInfo: null,
      all: {},
    }
  },
  watch: {
    orderNo: {
      handler() {
        if (!this.orderNo) {
          return
        }
        this.getCommissons()
      },
      immediate: true,
    },
    policyNo: {
      handler() {
        if (!this.policyNo) {
          return
        }
        this.getCommissons()
      },
      immediate: true,
    },
  },
  created() {
    this.userInfo = this.$tools.getLocal('userinfo')
    this.$tools.getall(data => {
      this.all = data;
    });
  },
  mounted() { },
  methods: {
    switchBox(bean, i) {
      if (i == 0) {
        // this.$set(bean, 'close', !bean.close)
      }
    },
    // 获取保单费用（服务费）
    getCommissons() {
      this.$http({
        url: '/master/policy/queryPolicyCommissonsList',
        type: 'put',
        params: {
          orderNo: this.orderNo,
          policyNo: this.policyNo,
        },
      }).then((res) => {
        this.loading = false
        console.log(res.data, 'res.datares.data11')
        const com = res.data
        const arr = []
        // 补贴处理
        com.map((item) => {
          if (
            (item.commission == '' || item.commission == null) &&
            (item.subsidyCommission == '' || item.subsidyCommission == null)
          ) {
            item.serviceCharge = '-'
          } else if (
            item.commission == '0.0' &&
            item.subsidyCommission == '0.0'
          ) {
            item.serviceCharge = '-'
          } else if (
            item.subsidyCommission == '0.0' ||
            item.subsidyCommission == null
          ) {
            item.serviceCharge = this.percent(item.commission)
          } else if (item.commission == '0.0' || item.commission == null) {
            item.serviceCharge = this.percent(item.subsidyCommission) + '补贴'
          } else {
            item.serviceCharge =
              this.percent(item.commission) +
              '+' +
              this.percent(item.subsidyCommission) +
              '补贴'
          }
          if (item.isPostf == 1) {
            item.payNum = 99;
          }
          this.pushData(arr, item)
        })
        this.addHeji(arr)
        this.data = arr
        console.log('arr', arr)
      })
    },
    pushData(list, bean) {
      let isAdd = true
      // 保单层
      list.forEach((item) => {
        if (item.policyNo == bean.policyNo) {
          isAdd = false
          let isAdd2 = true
          // 期数层
          item.children.forEach((item2) => {
            if (item2.payNum == bean.payNum) {
              isAdd2 = false
              let isAdd3 = true
              // 团队等级
              item2.children.forEach((item3) => {
                if (item3.level == bean.level) {
                  isAdd3 = false
                  item3.children.push(bean)
                }
              })
              if (isAdd3) {
                item2.children.push({
                  spcMechanName: bean.spcMechanName,
                  level: bean.level,
                  children: [bean],
                })
              }
            }
          })
          if (isAdd2) {
            item.children.push({
              payNum: bean.payNum,
              children: [
                {
                  level: bean.level,
                  spcMechanName: bean.spcMechanName,
                  children: [bean],
                },
              ],
            })
          }
        }
      })
      if (isAdd) {
        list.push({
          policyNo: bean.policyNo,
          children: [
            {
              payNum: bean.payNum,
              children: [
                {
                  level: bean.level,
                  spcMechanName: bean.spcMechanName,
                  children: [bean],
                },
              ],
            },
          ],
        })
      }
    },
    // 添加统计数据
    addHeji(data) {
      data.forEach(item => {
        item.children && item.children.forEach(item2 => {
          item2.children && item2.children.forEach(item3 => {
            console.log("item3", item3)
            if (item3.children && item3.children.length > 1) {
              let fee = 0;
              let totalIncomes = 0;
              let profit = 0;
              item3.children.forEach(item4 => {
                fee = (fee + item4.fee * 1).toFixed(2) * 1;
                totalIncomes = (totalIncomes + item4.totalIncomes * 1).toFixed(2) * 1;
                profit = (profit + item4.profit * 1).toFixed(2) * 1;
              })
              item3.children.push({
                isHeji: true,
                fee,
                totalIncomes,
                profit,
                productName: "合计",
                serviceCharge: "-",
              })
            }
          })
        })
      })
    },
    //小数点转换为百分比
    percent(val, size = 2) {
      var str
      if (!val || val == 0) {
        str = ''
      } else {
        str = val * 100
        str = str.toFixed(size) * 1 + '%'
      }
      return str
    },
    openRecord(value, index) {
      let obj = {
        type: value.level,
      }
      if (value.isPostf == 1) {//后置费用
        obj.policyCommissonsPostfId = value.id;
      } else {
        obj.policyCommissonsId = value.id;
      }
      console.log(value)
      this.$http({
        url: '/master/policy/queryCommissonsBalancePolicy',
        type: 'PUT',
        params: obj,
      }).then((res) => {
        this.recordList = res.data
        this.$nextTick(() => {
          if (this.$refs.popover) {
            this.$refs.popover[index].updatePopper()
          }
        })
      })
    },
    /**
     * 根据期数编码获取中文期数显示
     * @param num - 期数编码（1-5表示第1-5年，99表示首期后置）
     * @returns 中文期数显示文本
     */
    getPayNum(num) {
      if (num == '1') return '首年'
      if (num == '99') return '首期后置'
      const n = parseInt(num)
      const chineseMap = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      // 处理 10-99 的两位数
      if (n >= 10 && n < 100) {
        const ten = Math.floor(n / 10)
        const unit = n % 10
        // 十位数为1时读作"十"（如10读"十"而非"一十"）
        let str = ten === 1 ? '十' : chineseMap[ten] + '十'
        if (unit > 0) {
          str += chineseMap[unit]
        }
        return `第${str}年`
      }
      // 处理 1-9 的个位数
      const chineseNum = String(num).split('').map(d => chineseMap[parseInt(d)]).join('')
      return `第${chineseNum}年`
    },
  },
  filters: {
    // 结算状态
    filterBalanceStatus(val) {
      let str = ''
      if (val === '-1') {
        str = '不符合结算条件'
        return str
      } else if (val === '0') {
        str = '未结算'
        return str
      } else if (val === '1') {
        str = '已结算'
        return str
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './commissonsDetail.scss';
</style>
